'use client'
import { useEffect } from 'react'

const useInitKakaoSdk = () => {
  useEffect(() => {
    const naviScript = document.createElement('script')
    naviScript.async = true
    naviScript.src = 'https://t1.kakaocdn.net/kakao_js_sdk/2.3.0/kakao.min.js'
    naviScript.integrity = 'sha384-70k0rrouSYPWJt7q9rSTKpiTfX6USlMYjZUtr1Du+9o4cGvhPAWxngdtVZDdErlh'
    naviScript.crossOrigin = 'anonymous'

    document.head.appendChild(naviScript)

    const onLoadKakaoSDK = () => {
      window.Kakao.init(process.env.NEXT_PUBLIC_KAKAO_API_JS_KEY || '')
    }

    naviScript.addEventListener('load', onLoadKakaoSDK)

    return () => {
      document.head.removeChild(naviScript)
      naviScript.removeEventListener('load', onLoadKakaoSDK)
    }
  }, [])
}

export { useInitKakaoSdk }
